import { render, staticRenderFns } from "./not_found.vue?vue&type=template&id=5283092e&scoped=true&"
import script from "./not_found.vue?vue&type=script&lang=js&"
export * from "./not_found.vue?vue&type=script&lang=js&"
import style0 from "./not_found.vue?vue&type=style&index=0&id=5283092e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5283092e",
  null
  
)

export default component.exports